(function(){
  'use strict';

  var cfg=window.CoreOptimiseAccountConfig||{};
  var signedIn=!!cfg.signedIn;
  var customerId=String(cfg.customerId||'').trim();
  var guestKey='coreoptimise_guest_v5';
  var customerKey=customerId?'coreoptimise_account_'+customerId+'_v5':guestKey;
  var legacyKeys=customerId?[
    'coreoptimise_account_'+customerId+'_v4',
    'coreoptimise_account_'+customerId+'_v3',
    'coreoptimise_account_'+customerId+'_v2',
    'coreoptimise_account_'+customerId+'_v1'
  ]:[];
  var defaults={
    stack:[],analyses:[],comparisons:[],audits:[],checks:[],activity:[],
    stackVersions:[],productChanges:[],feedback:[],conflicts:[],undo:[],decisionHistory:[],
    personalisation:{
      displayName:'',
      displayNameUpdatedAt:null,
      avatar:{hasAvatar:false,updatedAt:null,version:''}
    },
    platform:{
      schemaVersion:1,
      accessMode:'free_early_access',
      plan:'early_access',
      paymentRequired:false,
      billing:{enabled:false,status:'not_required',provider:'not_configured'},
      features:{
        analyse:true,compare:true,form_checker:true,audit:true,my_stack:true,
        saved_intelligence:true,health_context:true,context_intelligence:true,
        connected_health:true,health_trends:true,health_snapshots:true,
        unlimited_history:true,advanced_exports:true,routine_reviews:true,
        check_before_add:true,blood_context:true
      },
      neutrality:{
        framework:'coreoptimise-intelligence-neutral-v1',
        statement:'CoreOptimise® products and other products use the same saved-label and evidence-context framework.',
        brandPreference:false
      },
      usage:{
        firstSeenAt:null,lastSeenAt:null,lastSessionAt:null,sessions:0,
        returned7d:false,returned30d:false,events:[]
      },
      reviewPreferences:{
        enabled:false,cadenceDays:30,lastReviewAt:null,nextReviewAt:null
      }
    }
  };

  function cloneDefaults(){return JSON.parse(JSON.stringify(defaults))}
  function normalizePersonalisation(input){
    input=isPlainObject(input)?input:{};
    var avatar=isPlainObject(input.avatar)?input.avatar:{};
    return{
      displayName:String(input.displayName||'').trim().slice(0,50),
      displayNameUpdatedAt:String(input.displayNameUpdatedAt||'').slice(0,60)||null,
      avatar:{
        hasAvatar:!!avatar.hasAvatar,
        updatedAt:String(avatar.updatedAt||'').slice(0,60)||null,
        version:String(avatar.version||'').slice(0,80)
      }
    }
  }
  function personalisation(){
    return JSON.parse(JSON.stringify(read().personalisation))
  }
  function setDisplayName(value){
    var d=read(),name=String(value||'').trim().replace(/\s+/g,' ').slice(0,50);
    d.personalisation=normalizePersonalisation(d.personalisation);
    d.personalisation.displayName=name;
    d.personalisation.displayNameUpdatedAt=now();
    trackUsageInStore(d,'display_name_updated',{surface:'profile',status:name?'set':'cleared'});
    write(d);
    return personalisation()
  }
  function setAvatarMeta(meta){
    var d=read(),m=isPlainObject(meta)?meta:{};
    d.personalisation=normalizePersonalisation(d.personalisation);
    d.personalisation.avatar={
      hasAvatar:m.hasAvatar!==false,
      updatedAt:String(m.updatedAt||now()).slice(0,60),
      version:String(m.version||Date.now()).slice(0,80)
    };
    trackUsageInStore(d,'profile_photo_updated',{surface:'profile',status:d.personalisation.avatar.hasAvatar?'set':'removed'});
    write(d);
    return personalisation()
  }
  function clearAvatarMeta(){
    return setAvatarMeta({hasAvatar:false,updatedAt:now(),version:String(Date.now())})
  }

  function normalizePlatform(input){
    input=isPlainObject(input)?input:{};
    var d=cloneDefaults().platform;
    var out=Object.assign({},d,input);
    // V6 Early Access is intentionally fully open. No paywall is enforced.
    out.accessMode='free_early_access';
    out.plan='early_access';
    out.paymentRequired=false;
    out.billing=Object.assign({},d.billing,isPlainObject(input.billing)?input.billing:{});
    out.billing.enabled=false;
    out.billing.status='not_required';
    out.features=Object.assign({},d.features,isPlainObject(input.features)?input.features:{});
    Object.keys(d.features).forEach(function(k){out.features[k]=true});
    out.neutrality=Object.assign({},d.neutrality,isPlainObject(input.neutrality)?input.neutrality:{});
    out.neutrality.brandPreference=false;
    out.usage=Object.assign({},d.usage,isPlainObject(input.usage)?input.usage:{});
    out.usage.events=arr(out.usage.events).slice(0,250);
    out.reviewPreferences=Object.assign({},d.reviewPreferences,isPlainObject(input.reviewPreferences)?input.reviewPreferences:{});
    return out
  }
  function safeUsageMeta(meta){
    meta=isPlainObject(meta)?meta:{};
    var allowed=['surface','type','status','source','action','result','countBucket','mode','cadence','feature'];
    var out={};
    allowed.forEach(function(k){
      if(meta[k]===undefined||meta[k]===null)return;
      var v=String(meta[k]).slice(0,80);
      if(v)out[k]=v
    });
    return out
  }
  function trackUsageInStore(d,event,meta){
    d.platform=normalizePlatform(d.platform);
    var usage=d.platform.usage,stamp=now(),name=String(event||'').trim().slice(0,80);
    if(!name)return;
    usage.events=arr(usage.events);
    usage.events.unshift({id:uid(),event:name,savedAt:stamp,meta:safeUsageMeta(meta)});
    usage.events=usage.events.slice(0,250);
    usage.lastSeenAt=stamp;
    if(!usage.firstSeenAt)usage.firstSeenAt=stamp
  }
  function trackUsage(event,meta){
    var d=read();trackUsageInStore(d,event,meta);return write(d)
  }
  function commercialState(){
    var p=read().platform;
    return{
      accessMode:p.accessMode,
      plan:p.plan,
      paymentRequired:false,
      allCurrentFeaturesFree:true,
      features:Object.assign({},p.features),
      billing:Object.assign({},p.billing),
      neutrality:Object.assign({},p.neutrality)
    }
  }
  function entitled(feature){
    var p=read().platform;
    return p.accessMode==='free_early_access' ? true : p.features[String(feature||'')]!==false
  }
  function featureFlags(){return Object.assign({},read().platform.features)}
  function reviewDue(){
    var p=read().platform.reviewPreferences||{},days=Math.max(1,Number(p.cadenceDays)||30);
    if(!p.enabled)return{enabled:false,due:false,nextReviewAt:null,cadenceDays:days};
    var last=p.lastReviewAt?new Date(p.lastReviewAt).getTime():0;
    var next=p.nextReviewAt?new Date(p.nextReviewAt).getTime():(last?last+days*86400000:Date.now());
    return{enabled:true,due:Date.now()>=next,nextReviewAt:new Date(next).toISOString(),cadenceDays:days,lastReviewAt:p.lastReviewAt||null}
  }
  function setReviewPreferences(patch){
    patch=isPlainObject(patch)?patch:{};
    var d=read(),r=d.platform.reviewPreferences=Object.assign({},d.platform.reviewPreferences,patch);
    r.enabled=!!r.enabled;
    r.cadenceDays=Math.max(7,Math.min(365,Number(r.cadenceDays)||30));
    if(r.enabled&&!r.nextReviewAt){
      r.nextReviewAt=new Date(Date.now()+r.cadenceDays*86400000).toISOString()
    }
    if(!r.enabled)r.nextReviewAt=null;
    trackUsageInStore(d,'routine_review_preference',{status:r.enabled?'enabled':'disabled',cadence:String(r.cadenceDays)});
    write(d);return Object.assign({},r)
  }
  function markReviewComplete(){
    var d=read(),r=d.platform.reviewPreferences,stamp=now(),days=Math.max(7,Number(r.cadenceDays)||30);
    r.lastReviewAt=stamp;
    r.nextReviewAt=r.enabled?new Date(Date.now()+days*86400000).toISOString():null;
    trackUsageInStore(d,'routine_review_completed',{surface:'my_coreoptimise'});
    write(d);return Object.assign({},r)
  }
  function registerSession(){
    var d=read(),u=d.platform.usage,stamp=now(),t=Date.now(),last=u.lastSessionAt?new Date(u.lastSessionAt).getTime():0;
    if(last&&t-last<6*3600000)return;
    var wasFirst=!u.firstSeenAt,first=u.firstSeenAt?new Date(u.firstSeenAt).getTime():t;
    u.sessions=(Number(u.sessions)||0)+1;u.lastSessionAt=stamp;u.lastSeenAt=stamp;if(!u.firstSeenAt)u.firstSeenAt=stamp;
    if(wasFirst&&signedIn)trackUsageInStore(d,'account_first_seen',{surface:'my_coreoptimise',mode:'signed_in'});
    trackUsageInStore(d,'session_opened',{surface:'my_coreoptimise',mode:signedIn?'signed_in':'guest'});
    var ageDays=(t-first)/86400000;
    if(ageDays>=7&&!u.returned7d){u.returned7d=true;trackUsageInStore(d,'returned_7d',{surface:'my_coreoptimise'})}
    if(ageDays>=30&&!u.returned30d){u.returned30d=true;trackUsageInStore(d,'returned_30d',{surface:'my_coreoptimise'})}
    safeSet(customerKey,normalizeStore(d));scheduleSyncPush()
  }
  function uid(){return 'co_'+Date.now().toString(36)+'_'+Math.random().toString(36).slice(2,9)}
  function now(){return new Date().toISOString()}
  function arr(v){return Array.isArray(v)?v:[]}
  function uniqueStrings(v){
    var out=[],seen={};
    arr(v).forEach(function(x){
      var s=String(x||'').trim(),k=s.toLowerCase();
      if(s&&!seen[k]){seen[k]=1;out.push(s)}
    });
    return out
  }
  function confidenceFromCompleteness(completeness,source){
    var c=String(completeness||'').toLowerCase(),src=String(source||'').toLowerCase();
    if(/complete|full|passport/.test(c))return 'High confidence';
    if(/partial|purchase record|audit label/.test(c))return 'Medium confidence';
    if(/lookup|label scan|ocr/.test(src))return 'Medium confidence';
    return 'Low confidence'
  }
  function identityConfidenceFromSource(source,confidence){
    var s=String(source||'').toLowerCase(),c=String(confidence||'').toLowerCase();
    if(/verified coreoptimise|formula passport|verified/.test(s+' '+c))return 'Verified';
    if(/barcode|smart product lookup|lookup/.test(s))return 'High';
    if(/label scan|ocr|audit/.test(s))return 'Medium';
    if(/user confirmed/.test(c))return 'User confirmed';
    return 'Low'
  }
  function isPlainObject(v){return !!v&&typeof v==='object'&&!Array.isArray(v)}
  function cleanObject(v){return isPlainObject(v)?Object.assign({},v):{}}
  function meaningful(v){
    if(Array.isArray(v))return v.length>0;
    if(isPlainObject(v))return Object.keys(v).length>0;
    return String(v==null?'':v).trim()!==''
  }
  function defaultProvenance(item){
    var source=String(item.source||'Saved data'),stamp=String(item.dataUpdatedAt||item.lastAnalysed||item.savedAt||now());
    var p=cleanObject(item.provenance),fresh=cleanObject(item.fieldFreshness);
    ['brand','dose','cost','actives','forms','premiumForms','purpose','notes','dataCompleteness'].forEach(function(k){
      if(meaningful(item[k])&&!p[k])p[k]={source:source,capturedAt:stamp};
      if(meaningful(item[k])&&!fresh[k])fresh[k]=stamp
    });
    if(!p.identity)p.identity={source:source,capturedAt:stamp};
    if(!fresh.identity)fresh.identity=stamp;
    return{provenance:p,fieldFreshness:fresh}
  }
  function normalizeItem(item,type){
    item=item&&typeof item==='object'?item:{};
    var x=Object.assign({},item);
    if(!x.id)x.id=uid();
    if(!x.savedAt)x.savedAt=now();

    if(type==='stack'){
      x.name=String(x.name||x.title||'Supplement').trim();
      x.brand=String(x.brand||'').trim();
      x.dose=String(x.dose||'').trim();
      x.cost=String(x.cost||'').trim();
      x.source=String(x.source||'Manual').trim();
      x.productUrl=String(x.productUrl||x.url||'').trim();
      x.analysisUrl=String(x.analysisUrl||'').trim();
      x.lastAnalysed=String(x.lastAnalysed||'').trim();
      x.dataCompleteness=String(x.dataCompleteness||'Basic').trim();
      x.confidence=String(x.confidence||confidenceFromCompleteness(x.dataCompleteness,x.source)).trim();
      x.actives=uniqueStrings(x.actives);
      x.forms=uniqueStrings(x.forms);
      x.premiumForms=uniqueStrings(x.premiumForms);
      x.notes=String(x.notes||'').trim();
      x.purpose=String(x.purpose||'').trim();
      x.priceCapturedAt=String(x.priceCapturedAt||'').trim();
      x.dataUpdatedAt=String(x.dataUpdatedAt||x.lastAnalysed||x.savedAt||now()).trim();
      x.identityConfidence=String(x.identityConfidence||identityConfidenceFromSource(x.source,x.confidence)).trim();
      x.identityConfirmed=Boolean(x.identityConfirmed);
      x.provenance=cleanObject(x.provenance);
      x.fieldFreshness=cleanObject(x.fieldFreshness);
      var prov=defaultProvenance(x);
      x.provenance=prov.provenance;
      x.fieldFreshness=prov.fieldFreshness;
    }else{
      x.title=String(x.title||x.name||'Saved Intelligence').trim();
      x.summary=String(x.summary||'').trim();
      x.meta=String(x.meta||'').trim();
      x.href=String(x.href||x.url||'').trim();
      x.source=String(x.source||'CoreOptimise® Intelligence').trim();
      x.confidence=String(x.confidence||'').trim();
      x.dataUpdatedAt=String(x.dataUpdatedAt||x.savedAt||now()).trim();
      x.actives=uniqueStrings(x.actives);
      x.forms=uniqueStrings(x.forms);
      x.premiumForms=uniqueStrings(x.premiumForms);
      if(x.payload===undefined)x.payload=null;
    }
    return x
  }
  function activityTitle(type,item){
    var title=String((item&&((item.name)||(item.title)))||'').trim();
    if(type==='stack')return 'Stack updated'+(title?' · '+title:'');
    if(type==='analyses')return 'Analysis saved'+(title?' · '+title:'');
    if(type==='comparisons')return 'Comparison saved'+(title?' · '+title:'');
    if(type==='audits')return 'Supplement Audit saved'+(title?' · '+title:'');
    if(type==='checks')return 'Form check saved'+(title?' · '+title:'');
    return title||'My CoreOptimise® updated'
  }
  function pushActivity(d,type,item,summary,href){
    if(type==='activity')return;
    d.activity=arr(d.activity);
    d.activity.unshift(normalizeItem({
      title:activityTitle(type,item),
      summary:String(summary||'').trim(),
      meta:type,
      href:String(href||item?.href||'').trim(),
      savedAt:now()
    },'activity'));
    d.activity=d.activity.slice(0,60)
  }
  function parseCost(v){
    var m=String(v||'').replace(',','.').match(/(\d+(?:\.\d+)?)/);
    return m?Number(m[1]):null
  }
  function stackSnapshotFromStore(d){
    d=d||read();
    var names=[],actives=[],forms=[],premium=[],dailyCost=0,costKnown=0,purposes={};
    arr(d.stack).forEach(function(i){
      names.push(String(i.name||'').trim());
      var purpose=String(i.purpose||'Unassigned').trim()||'Unassigned';
      purposes[purpose]=(purposes[purpose]||0)+1;
      arr(i.actives).forEach(function(x){actives.push(String(x||'').trim())});
      arr(i.forms).forEach(function(x){forms.push(String(x||'').trim())});
      arr(i.premiumForms).forEach(function(x){premium.push(String(x||'').trim())});
      var c=parseCost(i.cost);
      if(c!==null){dailyCost+=c;costKnown++}
    });
    function lowerSet(items){
      var m={};
      items.forEach(function(x){var s=String(x||'').trim();if(s)m[s.toLowerCase()]=s});
      return m
    }
    return{
      createdAt:now(),
      names:Object.values(lowerSet(names)),
      actives:Object.values(lowerSet(actives)),
      forms:Object.values(lowerSet(forms)),
      premiumForms:Object.values(lowerSet(premium)),
      productCount:arr(d.stack).length,
      monthlyCost:costKnown?Number((dailyCost*30.4).toFixed(2)):null,
      purposes:purposes,
      updatedAt:now()
    }
  }
  function compareWithStack(candidate){
    candidate=candidate&&typeof candidate==='object'?candidate:{};
    var d=read(),snap=stackSnapshotFromStore(d);
    var stackActives={};
    snap.actives.forEach(function(x){stackActives[String(x).toLowerCase()]=x});
    var cand=uniqueStrings(candidate.actives||[]);
    var overlaps=[],newActives=[];
    cand.forEach(function(x){
      if(stackActives[String(x).toLowerCase()])overlaps.push(x);
      else newActives.push(x)
    });
    var c=parseCost(candidate.costDaily||candidate.cost||'');
    return{
      candidateName:String(candidate.name||candidate.title||'This product'),
      stackProducts:snap.productCount,
      overlapActives:overlaps,
      newActives:newActives,
      monthlyCostDelta:c!==null?Number((c*30.4).toFixed(2)):null,
      productCountAfter:snap.productCount+1,
      currentMonthlyCost:snap.monthlyCost,
      estimatedMonthlyCostAfter:(snap.monthlyCost!==null&&c!==null)?Number((snap.monthlyCost+c*30.4).toFixed(2)):null,
      note:'Overlap is label-data context only. It does not by itself mean the combined intake is inappropriate.'
    }
  }
  function changesSinceLastAudit(){
    var d=read();
    var audit=arr(d.audits).find(function(a){return a&&a.payload&&a.payload.snapshot});
    if(!audit)return{hasAudit:false,changes:[],audit:null,current:stackSnapshotFromStore(d)};
    var old=audit.payload.snapshot||{},cur=stackSnapshotFromStore(d),changes=[];
    var oldNames=(old.names||[]).map(function(x){return String(x).toLowerCase()});
    var curNames=(cur.names||[]).map(function(x){return String(x).toLowerCase()});
    var added=(cur.names||[]).filter(function(x){return oldNames.indexOf(String(x).toLowerCase())<0});
    var removed=(old.names||[]).filter(function(x){return curNames.indexOf(String(x).toLowerCase())<0});
    if(added.length)changes.push({type:'added',text:added.length+' supplement'+(added.length===1?'':'s')+' added: '+added.join(', ')});
    if(removed.length)changes.push({type:'removed',text:removed.length+' supplement'+(removed.length===1?'':'s')+' removed: '+removed.join(', ')});
    if(old.monthlyCost!=null&&cur.monthlyCost!=null){
      var delta=Number((cur.monthlyCost-old.monthlyCost).toFixed(2));
      if(Math.abs(delta)>=0.01)changes.push({type:'cost',text:'Estimated monthly cost '+(delta>0?'increased':'decreased')+' by £'+Math.abs(delta).toFixed(2)});
    }
    var oldAct=(old.actives||[]).map(function(x){return String(x).toLowerCase()});
    var curAct=(cur.actives||[]).map(function(x){return String(x).toLowerCase()});
    var newAct=(cur.actives||[]).filter(function(x){return oldAct.indexOf(String(x).toLowerCase())<0});
    if(newAct.length)changes.push({type:'actives',text:newAct.length+' new identified active ingredient'+(newAct.length===1?'':'s')+' in the saved Stack data'});
    return{hasAudit:true,changes:changes,audit:audit,current:cur}
  }
  function recentActivity(limit){
    return arr(read().activity).slice(0,Number(limit)||8)
  }
  function stackSignature(snapshot){
    snapshot=snapshot||{};
    return JSON.stringify({
      names:(snapshot.names||[]).slice().sort(),
      monthlyCost:snapshot.monthlyCost,
      purposes:snapshot.purposes||{}
    })
  }
  function recordStackVersion(d,reason){
    d.stackVersions=arr(d.stackVersions);
    var snap=stackSnapshotFromStore(d);
    var last=d.stackVersions[0];
    if(last&&last.payload&&stackSignature(last.payload.snapshot)===stackSignature(snap))return;
    d.stackVersions.unshift(normalizeItem({
      title:'Stack version',
      summary:String(reason||'Stack updated'),
      meta:snap.productCount+' products',
      savedAt:now(),
      payload:{snapshot:snap,stack:JSON.parse(JSON.stringify(d.stack||[]))}
    },'stackVersions'));
    d.stackVersions=d.stackVersions.slice(0,40)
  }
  function comparableValue(v){
    if(Array.isArray(v))return uniqueStrings(v).map(function(x){return x.toLowerCase()}).sort().join('|');
    return String(v==null?'':v).trim().toLowerCase()
  }
  function detectProductChanges(existing,incoming){
    var fields=[
      ['dose','Daily dose'],
      ['cost','Daily cost'],
      ['actives','Active ingredients'],
      ['forms','Ingredient forms'],
      ['premiumForms','Premium forms'],
      ['dataCompleteness','Data completeness']
    ],out=[];
    fields.forEach(function(pair){
      var k=pair[0],label=pair[1],a=existing[k],b=incoming[k];
      if(meaningful(a)&&meaningful(b)&&comparableValue(a)!==comparableValue(b))out.push({key:k,label:label,before:a,after:b})
    });
    return out
  }
  function mergeStackItem(existing,incoming,allowOverwrite){
    var out=Object.assign({},existing),date=String(incoming.dataUpdatedAt||now());
    ['brand','dose','cost','source','productUrl','analysisUrl','lastAnalysed','dataCompleteness','confidence','notes','purpose','priceCapturedAt','dataUpdatedAt','identityConfidence'].forEach(function(k){
      if(meaningful(incoming[k])&&(allowOverwrite||!meaningful(out[k])))out[k]=incoming[k]
    });
    ['actives','forms','premiumForms'].forEach(function(k){
      if(arr(incoming[k]).length&&(allowOverwrite||!arr(out[k]).length))out[k]=uniqueStrings(incoming[k])
    });
    if(incoming.identityConfirmed)out.identityConfirmed=true;
    out.provenance=cleanObject(existing.provenance);
    out.fieldFreshness=cleanObject(existing.fieldFreshness);
    var ip=cleanObject(incoming.provenance),iff=cleanObject(incoming.fieldFreshness);
    Object.keys(ip).forEach(function(k){if(allowOverwrite||!out.provenance[k])out.provenance[k]=ip[k]});
    Object.keys(iff).forEach(function(k){if(allowOverwrite||!out.fieldFreshness[k])out.fieldFreshness[k]=iff[k]});
    if(allowOverwrite){
      ['dose','cost','actives','forms','premiumForms','dataCompleteness'].forEach(function(k){
        if(meaningful(incoming[k])){
          out.provenance[k]=ip[k]||{source:incoming.source||'Refreshed product data',capturedAt:date};
          out.fieldFreshness[k]=iff[k]||date
        }
      })
    }
    return normalizeItem(out,'stack')
  }
  function addProductChange(d,existing,incoming,fields){
    if(!fields.length)return;
    d.productChanges=arr(d.productChanges);
    d.productChanges.unshift(normalizeItem({
      title:(incoming.name||existing.name||'Saved product')+' changed',
      summary:fields.join(' · '),
      meta:'Detected when saved product data was refreshed',
      savedAt:now(),
      payload:{productId:existing.id,fields:fields,before:existing,after:incoming}
    },'productChanges'));
    d.productChanges=d.productChanges.slice(0,40)
  }
  function snapshotForUndo(d){
    var keys=['stack','analyses','comparisons','audits','checks','activity','stackVersions','productChanges','feedback','conflicts','decisionHistory'];
    var out={};
    keys.forEach(function(k){out[k]=JSON.parse(JSON.stringify(arr(d[k])))});
    return out
  }
  function pushUndo(d,label){
    d.undo=arr(d.undo);
    d.undo.unshift(normalizeItem({
      title:String(label||'Undo last change'),
      summary:'Temporary restore point',
      meta:'undo',
      savedAt:now(),
      payload:{store:snapshotForUndo(d)}
    },'undo'));
    d.undo=d.undo.slice(0,5)
  }
  function undoLast(){
    var d=read(),entry=arr(d.undo)[0];
    if(!entry?.payload?.store)return false;
    var remaining=arr(d.undo).slice(1),restored=normalizeStore(entry.payload.store);
    restored.undo=remaining;
    safeSet(customerKey,restored);
    emit(restored);
    return true
  }
  function createConflict(d,existing,incoming,fields){
    d.conflicts=arr(d.conflicts);
    var conflict=normalizeItem({
      title:(incoming.name||existing.name||'Saved product')+' needs confirmation',
      summary:fields.map(function(f){return f.label}).join(' · '),
      meta:'Product information conflict',
      savedAt:now(),
      payload:{existing:existing,incoming:incoming,fields:fields}
    },'conflicts');
    d.conflicts.unshift(conflict);
    d.conflicts=d.conflicts.slice(0,30);
    return conflict
  }
  function resolveConflict(id,choice){
    var d=read(),c=arr(d.conflicts).find(function(x){return x.id===id});
    if(!c?.payload)return false;
    pushUndo(d,'Undo product conflict decision');
    var before=c.payload.existing,incoming=c.payload.incoming,index=d.stack.findIndex(function(i){return i.id===before.id});
    if(choice==='current'&&index>-1){
      var merged=mergeStackItem(d.stack[index],incoming,true);
      d.stack[index]=merged;
      addProductChange(d,before,merged,c.payload.fields||[]);
      pushActivity(d,'stack',merged,'Confirmed refreshed product data');
      recordStackVersion(d,'Confirmed updated product data for '+merged.name)
    }else{
      d.activity.unshift(normalizeItem({title:'Kept previous saved product data',summary:before.name||'',meta:'conflict',savedAt:now()},'activity'))
    }
    d.conflicts=d.conflicts.filter(function(x){return x.id!==id});
    write(d);
    return true
  }
  function compareStackVersion(id){
    var d=read(),v=arr(d.stackVersions).find(function(x){return x.id===id});
    if(!v?.payload)return null;
    var oldStack=arr(v.payload.stack);
    if(!oldStack.length&&v.payload.snapshot?.names){
      oldStack=v.payload.snapshot.names.map(function(name){return normalizeItem({name:name,source:'Historical Stack snapshot'},'stack')})
    }
    function mapStack(list){
      var map={};arr(list).forEach(function(i){map[(String(i.name||'')+'|'+String(i.brand||'')).toLowerCase()]=i});return map
    }
    var oldMap=mapStack(oldStack),curMap=mapStack(d.stack),added=[],removed=[],changed=[];
    Object.keys(curMap).forEach(function(k){
      if(!oldMap[k])added.push(curMap[k].name);
      else{
        var fields=[];
        [['dose','dose'],['cost','cost'],['purpose','purpose'],['actives','actives'],['forms','forms']].forEach(function(pair){
          if(comparableValue(oldMap[k][pair[0]])!==comparableValue(curMap[k][pair[0]]))fields.push(pair[1])
        });
        if(fields.length)changed.push({name:curMap[k].name,fields:fields})
      }
    });
    Object.keys(oldMap).forEach(function(k){if(!curMap[k])removed.push(oldMap[k].name)});
    return{version:v,added:added,removed:removed,changed:changed}
  }
  function restoreStackVersion(id){
    var d=read(),v=arr(d.stackVersions).find(function(x){return x.id===id});
    if(!v?.payload)return false;
    var oldStack=arr(v.payload.stack);
    if(!oldStack.length&&v.payload.snapshot?.names){
      oldStack=v.payload.snapshot.names.map(function(name){return normalizeItem({name:name,source:'Restored historical snapshot',dataCompleteness:'Basic'},'stack')})
    }
    pushUndo(d,'Undo Stack version restore');
    d.stack=oldStack.map(function(i){return normalizeItem(Object.assign({},i,{dataUpdatedAt:now()}),'stack')});
    pushActivity(d,'stack',{name:'Historical Stack'},'Restored Stack version from '+new Date(v.savedAt).toLocaleDateString());
    recordStackVersion(d,'Restored historical Stack version');
    write(d);
    return true
  }
  function recordDecisionJourney(d,item){
    var name=String(item?.name||'').toLowerCase();
    if(!name)return;
    var match=arr(d.comparisons).find(function(c){
      var when=new Date(c.savedAt||0).getTime();
      if(!when||Date.now()-when>90*86400000)return false;
      var products=arr(c.payload?.products);
      return products.some(function(p){return String(p?.name||'').toLowerCase()===name})
    });
    if(!match)return;
    d.decisionHistory=arr(d.decisionHistory);
    var duplicate=d.decisionHistory.some(function(x){return x.payload?.comparisonId===match.id&&String(x.payload?.product||'').toLowerCase()===name});
    if(duplicate)return;
    d.decisionHistory.unshift(normalizeItem({
      title:'Compared → Added to Stack',
      summary:item.name,
      meta:'Decision journey',
      savedAt:now(),
      payload:{comparisonId:match.id,product:item.name,comparisonTitle:match.title}
    },'decisionHistory'));
    d.decisionHistory=d.decisionHistory.slice(0,40)
  }
  function applyRoutineChanges(changes){
    changes=arr(changes);
    if(!changes.length)return false;
    var d=read(),byId={};
    changes.forEach(function(c){if(c&&c.id)byId[c.id]=c});
    pushUndo(d,'Undo routine changes');
    d.stack=d.stack.filter(function(i){
      var c=byId[i.id];
      return !c||c.still!==false
    }).map(function(i){
      var c=byId[i.id];
      if(!c)return i;
      return normalizeItem(Object.assign({},i,c.patch||{},{dataUpdatedAt:now()}),'stack')
    });
    d.activity.unshift(normalizeItem({title:'Routine updated',summary:'Multiple Stack changes saved together',meta:'stack',savedAt:now()},'activity'));
    d.activity=d.activity.slice(0,60);
    recordStackVersion(d,'Routine updated');
    write(d);
    return true
  }
  function identityConfirm(id){
    return updateStack(id,{identityConfirmed:true,identityConfidence:'User confirmed',confidence:'User confirmed'})
  }
  function fieldAgeDays(item,field){
    var v=item?.fieldFreshness?.[field]||item?.priceCapturedAt||item?.dataUpdatedAt||item?.savedAt;
    if(!v)return null;
    var t=new Date(v).getTime();if(!t)return null;
    return Math.max(0,Math.floor((Date.now()-t)/86400000))
  }
  function purposeCoverage(){
    var d=read(),m={};
    arr(d.stack).forEach(function(i){
      var p=String(i.purpose||'Unassigned').trim()||'Unassigned';
      m[p]=(m[p]||0)+1
    });
    return m
  }
  function searchSaved(query,limit){
    var q=String(query||'').trim().toLowerCase();
    if(!q)return[];
    var d=read(),out=[];
    ['stack','analyses','comparisons','audits','checks'].forEach(function(type){
      arr(d[type]).forEach(function(i){
        var hay=[
          i.name,i.title,i.brand,i.summary,i.meta,i.notes,i.purpose,i.source,
          ...(i.actives||[]),...(i.forms||[]),...(i.premiumForms||[])
        ].filter(Boolean).join(' ').toLowerCase();
        if(hay.indexOf(q)>-1){
          out.push({
            id:i.id,type:type,title:i.name||i.title||'Saved item',
            summary:i.summary||i.notes||i.meta||i.brand||'',
            href:i.href||i.analysisUrl||i.productUrl||'',
            savedAt:i.savedAt||i.dataUpdatedAt||''
          })
        }
      })
    });
    out.sort(function(a,b){return String(b.savedAt).localeCompare(String(a.savedAt))});
    return out.slice(0,Number(limit)||20)
  }
  function latestTimestamp(){
    var d=read(),times=[];
    ['stack','analyses','comparisons','audits','checks','activity'].forEach(function(k){
      arr(d[k]).forEach(function(i){if(i.savedAt)times.push(i.savedAt);if(i.dataUpdatedAt)times.push(i.dataUpdatedAt)})
    });
    times.sort().reverse();
    return times[0]||null
  }
  function reviewStatus(days){
    days=Number(days)||75;
    var d=read(),stackActs=arr(d.activity).filter(function(i){return /stack/i.test(String(i.meta||'')) || /Stack/.test(String(i.title||''))});
    var last=stackActs[0]?.savedAt||latestTimestamp();
    if(!last)return{due:false,last:null,daysAgo:null};
    var ago=Math.floor((Date.now()-new Date(last).getTime())/86400000);
    return{due:ago>=days,last:last,daysAgo:ago}
  }
  function feedback(type,context,useful){
    var d=read();
    d.feedback=arr(d.feedback);
    d.feedback.unshift(normalizeItem({
      title:'Intelligence feedback',
      summary:useful===true?'Useful':useful===false?'Not quite':'Feedback',
      meta:String(type||'Intelligence'),
      savedAt:now(),
      payload:{context:context||{},useful:useful}
    },'feedback'));
    d.feedback=d.feedback.slice(0,100);
    write(d);
    return true
  }
  function practitionerSummary(){
    var d=read(),snap=stackSnapshotFromStore(d);
    return{
      title:'CoreOptimise® Supplement Routine Summary',
      generatedAt:now(),
      privacy:'This export excludes customer name, email, addresses, orders and payment information.',
      disclaimer:'This is a user-maintained supplement record, not a clinical record or medical recommendation.',
      products:arr(d.stack).map(function(i){
        return{
          product:i.name,
          brand:i.brand||'',
          dailyDose:i.dose||'',
          purpose:i.purpose||'',
          notes:i.notes||'',
          declaredActives:i.actives||[],
          identifiedForms:i.forms||[],
          dataConfidence:i.confidence||confidenceFromCompleteness(i.dataCompleteness,i.source),
          identityConfidence:i.identityConfidence||'',
          provenance:i.provenance||{},
          fieldFreshness:i.fieldFreshness||{},
          lastUpdated:i.dataUpdatedAt||i.savedAt||''
        }
      }),
      summary:{
        productCount:snap.productCount,
        identifiedActives:snap.actives.length,
        premiumForms:snap.premiumForms.length,
        estimatedMonthlyCost:snap.monthlyCost
      }
    }
  }
  function exportPractitioner(){
    var p=practitionerSummary(),lines=[];
    lines.push(p.title);
    lines.push('Generated: '+new Date(p.generatedAt).toLocaleString());
    lines.push('');
    lines.push(p.privacy);
    lines.push(p.disclaimer);
    lines.push('');
    lines.push('ROUTINE');
    p.products.forEach(function(i,n){
      lines.push((n+1)+'. '+i.product+(i.brand?' — '+i.brand:''));
      if(i.dailyDose)lines.push('   Daily dose: '+i.dailyDose);
      if(i.purpose)lines.push('   Purpose: '+i.purpose);
      if(i.notes)lines.push('   Notes: '+i.notes);
      if(i.declaredActives.length)lines.push('   Declared actives: '+i.declaredActives.join(', '));
      if(i.identifiedForms.length)lines.push('   Identified forms: '+i.identifiedForms.join(', '));
      lines.push('   Data confidence: '+i.dataConfidence);
      if(i.identityConfidence)lines.push('   Product match confidence: '+i.identityConfidence);
      if(i.provenance&&i.provenance.dose)lines.push('   Dose source: '+String(i.provenance.dose.source||'Saved data'));
      if(i.provenance&&i.provenance.actives)lines.push('   Active-ingredient source: '+String(i.provenance.actives.source||'Saved data'));
      if(i.provenance&&i.provenance.forms)lines.push('   Form source: '+String(i.provenance.forms.source||'Saved data'));
      if(i.lastUpdated)lines.push('   Data last updated: '+i.lastUpdated);
    });
    var blob=new Blob([lines.join('\n')],{type:'text/plain'});
    var url=URL.createObjectURL(blob),a=document.createElement('a');
    a.href=url;a.download='coreoptimise-routine-summary-'+new Date().toISOString().slice(0,10)+'.txt';
    document.body.appendChild(a);a.click();a.remove();setTimeout(function(){URL.revokeObjectURL(url)},1000);
    return true
  }
  function htmlEscape(v){
    return String(v==null?'':v).replace(/[&<>"']/g,function(c){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]})
  }
  function printRoutinePassport(){
    var p=practitionerSummary(),w=window.open('','_blank','noopener,noreferrer');
    if(!w)return false;
    var rows=p.products.map(function(i){
      return '<tr><td><strong>'+htmlEscape(i.product)+'</strong>'+(i.brand?'<br><small>'+htmlEscape(i.brand)+'</small>':'')+'</td>'+
        '<td>'+htmlEscape(i.dailyDose||'—')+'</td>'+
        '<td>'+htmlEscape(i.purpose||'—')+'</td>'+
        '<td>'+htmlEscape((i.identifiedForms||[]).join(', ')||'—')+'</td>'+
        '<td>'+htmlEscape(i.dataConfidence||'—')+'</td></tr>'
    }).join('');
    var html='<!doctype html><html><head><meta charset="utf-8"><title>CoreOptimise Routine Intelligence Passport</title>'+
      '<style>@page{size:A4;margin:14mm}*{box-sizing:border-box}body{font-family:Arial,sans-serif;color:#222;margin:0}header{padding:24px;background:#1b1c1a;color:white;border-top:3px solid #b78a3d}header h1{margin:4px 0 0;font-size:28px}header p{color:#d6d1c7;font-size:11px;line-height:1.5}.brand{color:#e0bf68;font-size:10px;font-weight:700;letter-spacing:.12em}.metrics{display:grid;grid-template-columns:repeat(4,1fr);gap:7px;margin:14px 0}.metric{padding:12px;border:1px solid #ddd5c7;border-radius:8px}.metric span{display:block;color:#8b682d;font-size:8px;text-transform:uppercase}.metric b{display:block;margin-top:4px;font-size:15px}table{width:100%;border-collapse:collapse;font-size:9px}th,td{padding:9px;border-bottom:1px solid #e6ded0;text-align:left;vertical-align:top}th{color:#7e602c;text-transform:uppercase;font-size:7px}.note{margin-top:14px;padding:12px;background:#f7f3ea;border:1px solid #e1d7c5;border-radius:8px;font-size:8px;line-height:1.5}small{color:#777}@media print{button{display:none}}</style></head><body>'+
      '<header><div class="brand">COREOPTIMISE® ROUTINE INTELLIGENCE</div><h1>Routine Intelligence Passport</h1><p>Privacy-safe supplement record generated '+htmlEscape(new Date(p.generatedAt).toLocaleString())+'. This document excludes profile, order and payment information.</p></header>'+
      '<div class="metrics"><div class="metric"><span>Supplements</span><b>'+p.summary.productCount+'</b></div><div class="metric"><span>Identified actives</span><b>'+p.summary.identifiedActives+'</b></div><div class="metric"><span>Premium forms</span><b>'+p.summary.premiumForms+'</b></div><div class="metric"><span>Monthly cost</span><b>'+(p.summary.estimatedMonthlyCost==null?'—':'£'+Number(p.summary.estimatedMonthlyCost).toFixed(2))+'</b></div></div>'+
      '<table><thead><tr><th>Product</th><th>Daily dose</th><th>Purpose</th><th>Identified forms</th><th>Data confidence</th></tr></thead><tbody>'+rows+'</tbody></table>'+
      '<div class="note"><strong>Important:</strong> '+htmlEscape(p.disclaimer)+' Data is based on saved product/label information and should be checked against current labels when formulations change.</div>'+
      '<script>window.onload=function(){setTimeout(function(){window.print()},300)}<\/script></body></html>';
    w.document.open();w.document.write(html);w.document.close();
    return true
  }

  async function shareRoutine(){    var p=practitionerSummary();
    var text=p.title+'\n'+p.summary.productCount+' products · '+p.summary.identifiedActives+' identified actives · last updated '+(latestTimestamp()?new Date(latestTimestamp()).toLocaleDateString():'not recorded')+'\n\n'+p.disclaimer;
    if(navigator.share){
      try{await navigator.share({title:p.title,text:text});return true}catch(e){if(e&&e.name==='AbortError')return false}
    }
    try{await navigator.clipboard.writeText(text);return true}catch(e){return false}
  }
  function normalizeStore(data){
    var out=cloneDefaults();
    data=data&&typeof data==='object'?data:{};
    ['stack','analyses','comparisons','audits','checks','activity','stackVersions','productChanges','feedback','conflicts','undo','decisionHistory'].forEach(function(k){
      out[k]=arr(data[k]).map(function(i){return normalizeItem(i,k==='stack'?'stack':k)})
    });
    out.personalisation=normalizePersonalisation(data.personalisation);
    out.platform=normalizePlatform(data.platform);
    return out
  }
  function safeGet(key){try{return JSON.parse(localStorage.getItem(key)||'null')}catch(e){return null}}
  function safeSet(key,value){try{localStorage.setItem(key,JSON.stringify(value));return true}catch(e){return false}}
  function safeRemove(key){try{localStorage.removeItem(key)}catch(e){}}

  function mergeStores(a,b){
    var out=normalizeStore(a),inc=normalizeStore(b);

    // Stack is merged by product identity rather than random local IDs.
    // Existing values are never silently overwritten by conflicting remote values.
    var mergedStack=arr(out.stack).slice();
    arr(inc.stack).forEach(function(remote){
      var index=mergedStack.findIndex(function(local){
        return local.id===remote.id || (
          String(local.name||'').toLowerCase()===String(remote.name||'').toLowerCase() &&
          String(local.brand||'').toLowerCase()===String(remote.brand||'').toLowerCase()
        )
      });
      if(index<0){mergedStack.push(remote);return}
      var local=mergedStack[index],fields=detectProductChanges(local,remote);
      if(fields.length){
        var exists=arr(out.conflicts).some(function(c){
          return String(c.payload?.existing?.name||'').toLowerCase()===String(local.name||'').toLowerCase() &&
                 c.summary===fields.map(function(f){return f.label}).join(' · ')
        });
        if(!exists)createConflict(out,local,remote,fields)
      }else{
        mergedStack[index]=mergeStackItem(local,remote,false)
      }
    });
    out.stack=mergedStack;

    ['analyses','comparisons','audits','checks','activity','stackVersions','productChanges','feedback','conflicts','undo','decisionHistory'].forEach(function(k){
      var seen={},merged=[];
      arr(out[k]).concat(arr(inc[k])).forEach(function(item){
        var sig=(item.id||'')+'|'+String(item.name||item.title||'').toLowerCase()+'|'+String(item.savedAt||'');
        if(!seen[sig]){seen[sig]=1;merged.push(item)}
      });
      out[k]=merged
    });
    var aPersonal=normalizePersonalisation(out.personalisation),bPersonal=normalizePersonalisation(inc.personalisation);
    var aNameTime=aPersonal.displayNameUpdatedAt?new Date(aPersonal.displayNameUpdatedAt).getTime():0;
    var bNameTime=bPersonal.displayNameUpdatedAt?new Date(bPersonal.displayNameUpdatedAt).getTime():0;
    var aAvatarTime=aPersonal.avatar.updatedAt?new Date(aPersonal.avatar.updatedAt).getTime():0;
    var bAvatarTime=bPersonal.avatar.updatedAt?new Date(bPersonal.avatar.updatedAt).getTime():0;
    var chosenName=bNameTime>=aNameTime?bPersonal:aPersonal;
    out.personalisation={
      displayName:chosenName.displayName,
      displayNameUpdatedAt:chosenName.displayNameUpdatedAt,
      avatar:bAvatarTime>=aAvatarTime?bPersonal.avatar:aPersonal.avatar
    };
    var aPlat=normalizePlatform(out.platform),bPlat=normalizePlatform(inc.platform);
    var usageEvents=[],eventSeen={};
    arr(aPlat.usage.events).concat(arr(bPlat.usage.events)).forEach(function(ev){
      var sig=String(ev.id||'')+'|'+String(ev.event||'')+'|'+String(ev.savedAt||'');
      if(!eventSeen[sig]){eventSeen[sig]=1;usageEvents.push(ev)}
    });
    out.platform=normalizePlatform(Object.assign({},aPlat,bPlat,{
      usage:Object.assign({},aPlat.usage,bPlat.usage,{
        firstSeenAt:[aPlat.usage.firstSeenAt,bPlat.usage.firstSeenAt].filter(Boolean).sort()[0]||null,
        lastSeenAt:[aPlat.usage.lastSeenAt,bPlat.usage.lastSeenAt].filter(Boolean).sort().slice(-1)[0]||null,
        sessions:Math.max(Number(aPlat.usage.sessions)||0,Number(bPlat.usage.sessions)||0),
        returned7d:!!(aPlat.usage.returned7d||bPlat.usage.returned7d),
        returned30d:!!(aPlat.usage.returned30d||bPlat.usage.returned30d),
        events:usageEvents.slice(0,250)
      }),
      reviewPreferences:Object.assign({},aPlat.reviewPreferences,bPlat.reviewPreferences)
    }));
    return out
  }

  function migrate(){
    var current=safeGet(customerKey);
    if(!current&&signedIn&&customerId){
      for(var i=0;i<legacyKeys.length;i++){
        var legacy=safeGet(legacyKeys[i]);
        if(legacy){current=normalizeStore(legacy);break}
      }
    }
    if(!current&&!signedIn){
      var olderGuest=safeGet('coreoptimise_guest_v4')||safeGet('coreoptimise_guest_v2');
      if(olderGuest)current=normalizeStore(olderGuest)
    }
    if(signedIn&&customerId){
      var guest=mergeStores(mergeStores(safeGet('coreoptimise_guest_v4')||cloneDefaults(),safeGet('coreoptimise_guest_v2')||cloneDefaults()),safeGet(guestKey)||cloneDefaults());
      var hasGuest=Object.keys(guest).some(function(k){return Array.isArray(guest[k])&&guest[k].length});
      if(hasGuest){current=mergeStores(current||cloneDefaults(),guest);safeRemove('coreoptimise_guest_v4');safeRemove('coreoptimise_guest_v2');safeRemove(guestKey)}
    }
    if(!current)current=cloneDefaults();
    safeSet(customerKey,current)
  }

  function read(){return normalizeStore(safeGet(customerKey)||cloneDefaults())}
  function emit(data){
    document.dispatchEvent(new CustomEvent('coreoptimise:account-updated',{detail:{data:data||read(),mode:'hybrid-v6'}}))
  }
  function write(data){
    data=normalizeStore(data);
    if(safeSet(customerKey,data)){emit(data);scheduleSyncPush();return true}
    return false
  }
  function validType(type){return ['stack','analyses','comparisons','audits','checks'].indexOf(type)>-1}
  function save(type,item){
    if(!validType(type))return false;
    var d=read(),n=normalizeItem(item,type==='stack'?'stack':type);
    if(type==='audits'){
      n.payload=n.payload&&typeof n.payload==='object'?n.payload:{};
      if(!n.payload.snapshot)n.payload.snapshot=stackSnapshotFromStore(d)
    }
    d[type].unshift(n);
    pushActivity(d,type,n,n.summary,n.href);
    var usageEvent=type==='analyses'?'analysis_saved':type==='comparisons'?'comparison_saved':type==='audits'?'audit_saved':type==='checks'?'form_check_saved':'item_saved';
    trackUsageInStore(d,usageEvent,{surface:'intelligence',type:type});
    write(d);
    return n
  }
  function remove(type,id){
    if(!validType(type))return false;
    var d=read(),removed=arr(d[type]).find(function(i){return i.id===id});
    pushUndo(d,'Undo removing '+String(removed?.name||removed?.title||'saved item'));
    d[type]=arr(d[type]).filter(function(i){return i.id!==id});
    d.activity.unshift(normalizeItem({title:'Removed '+(type==='stack'?'Stack item':'saved '+type.slice(0,-1)),summary:String(removed?.name||removed?.title||''),meta:type,savedAt:now()},'activity'));
    d.activity=d.activity.slice(0,60);
    if(type==='stack')recordStackVersion(d,'Removed '+String(removed?.name||'supplement'));
    write(d);return true
  }
  function clear(type){
    if(!validType(type))return false;
    var d=read();pushUndo(d,'Undo clearing '+type);d[type]=[];
    if(type==='stack')recordStackVersion(d,'Stack cleared');
    write(d);return true
  }
  function updateStack(id,patch){
    var d=read(),found=false,updated=null;pushUndo(d,'Undo Stack edit');
    d.stack=d.stack.map(function(i){
      if(i.id!==id)return i;
      found=true;
      updated=normalizeItem(Object.assign({},i,patch||{},{dataUpdatedAt:now()}),'stack');
      return updated
    });
    if(found){pushActivity(d,'stack',updated,'Routine details updated');recordStackVersion(d,'Routine details updated');write(d)}
    return found
  }
  function addToStack(item){
    var d=read(),n=normalizeItem(Object.assign({},item||{},{dataUpdatedAt:now()}),'stack');
    var index=d.stack.findIndex(function(i){
      return String(i.name).toLowerCase()===String(n.name).toLowerCase() &&
             String(i.brand).toLowerCase()===String(n.brand).toLowerCase()
    });
    if(index<0){
      pushUndo(d,'Undo adding '+n.name);
      d.stack.unshift(n);
      pushActivity(d,'stack',n,'Added to My Supplement Stack');
      recordDecisionJourney(d,n);
      recordStackVersion(d,'Added '+n.name);
      trackUsageInStore(d,d.stack.length===1?'stack_first_product_added':'stack_product_added',{surface:'my_stack'});
      write(d);
      return{status:'added',item:n}
    }
    var existing=d.stack[index],fields=detectProductChanges(existing,n);
    if(fields.length){
      var conflict=createConflict(d,existing,n,fields);
      d.activity.unshift(normalizeItem({title:'Product information needs confirmation',summary:n.name+' · '+fields.map(function(f){return f.label}).join(', '),meta:'conflict',savedAt:now()},'activity'));
      write(d);
      return{status:'conflict',conflictId:conflict.id,fields:fields,item:existing}
    }
    var merged=mergeStackItem(existing,n,false),changed=JSON.stringify(existing)!==JSON.stringify(merged);
    if(changed){
      pushUndo(d,'Undo product data enrichment');
      d.stack[index]=merged;
      pushActivity(d,'stack',merged,'Added missing product context without replacing saved values');
      recordStackVersion(d,'Enriched '+merged.name);
      write(d);
      return{status:'enriched',item:merged}
    }
    return{status:'exists',item:existing}
  }
  function counts(){
    var d=read(),saved=0;
    ['analyses','comparisons','audits','checks'].forEach(function(k){saved+=d[k].length});
    return{stack:d.stack.length,saved:saved,analyses:d.analyses.length,comparisons:d.comparisons.length,audits:d.audits.length,checks:d.checks.length}
  }
  function clearIntelligence(){
    var d=read();
    pushUndo(d,'Undo clearing saved Intelligence');
    d.analyses=[];d.comparisons=[];d.audits=[];d.checks=[];
    write(d);
    return true
  }
  function exportData(){
    var payload={
      product:'My CoreOptimise®',
      version:6,
      storageMode:'hybrid-v6',
      exportedAt:now(),
      data:read()
    };
    var blob=new Blob([JSON.stringify(payload,null,2)],{type:'application/json'});
    var url=URL.createObjectURL(blob);
    var a=document.createElement('a');
    var date=new Date().toISOString().slice(0,10);
    a.href=url;
    a.download='my-coreoptimise-saved-data-'+date+'.json';
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(function(){URL.revokeObjectURL(url)},1000);
    return true
  }

  function saveAndOpen(type,item,anchor){
    var saved=save(type,item);
    var url=String(cfg.dashboardUrl||'/pages/my-coreoptimise')+(anchor||('#'+(type==='stack'?'stack':'saved')));
    if(!signedIn){
      var login=String(cfg.loginUrl||'/account/login'),sep=login.indexOf('?')>-1?'&':'?';
      window.location.href=login+sep+'return_url='+encodeURIComponent(url)
    }else window.location.href=url;
    return saved
  }

  var syncEndpoint=String(cfg.syncEndpoint||'').trim();
  var syncState={enabled:!!syncEndpoint,status:syncEndpoint?'ready':'local-only',lastSync:null,error:null};
  var syncPushTimer=0,syncInFlight=false;
  function scheduleSyncPush(){
    if(!syncEndpoint||!signedIn||syncInFlight)return;
    clearTimeout(syncPushTimer);
    syncPushTimer=setTimeout(function(){syncPush()},450)
  }
  async function syncPull(){
    if(!syncEndpoint||!signedIn)return false;
    syncState.status='syncing';syncInFlight=true;
    try{
      var r=await fetch(syncEndpoint,{method:'GET',credentials:'include',headers:{'Accept':'application/json'}});
      if(!r.ok)throw new Error('Sync pull '+r.status);
      var remote=await r.json();
      var merged=mergeStores(read(),remote&&remote.data?remote.data:remote);
      safeSet(customerKey,merged);
      syncState.status='synced';syncState.lastSync=now();syncState.error=null;emit(merged);return true
    }catch(e){syncState.status='error';syncState.error=String(e&&e.message||e);return false}
    finally{syncInFlight=false}
  }
  async function syncPush(){
    if(!syncEndpoint||!signedIn)return false;
    syncState.status='syncing';syncInFlight=true;
    try{
      var r=await fetch(syncEndpoint,{method:'POST',credentials:'include',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({data:read()})});
      if(!r.ok)throw new Error('Sync push '+r.status);
      syncState.status='synced';syncState.lastSync=now();syncState.error=null;return true
    }catch(e){syncState.status='error';syncState.error=String(e&&e.message||e);return false}
    finally{syncInFlight=false}
  }

  migrate();
  try{registerSession()}catch(e){}

  window.CoreOptimiseAccount={
    version:6.1,
    mode:'hybrid-v6',
    signedIn:signedIn,
    customerId:customerId,
    dashboardUrl:cfg.dashboardUrl||'/pages/my-coreoptimise',
    get:read,
    save:save,
    saveAndOpen:saveAndOpen,
    remove:remove,
    clear:clear,
    addToStack:addToStack,
    updateStack:updateStack,
    counts:counts,
    clearIntelligence:clearIntelligence,
    exportData:exportData,
    stackSnapshot:function(){return stackSnapshotFromStore(read())},
    compareWithStack:compareWithStack,
    changesSinceLastAudit:changesSinceLastAudit,
    recentActivity:recentActivity,
    search:searchSaved,
    purposeCoverage:purposeCoverage,
    latestTimestamp:latestTimestamp,
    reviewStatus:reviewStatus,
    feedback:feedback,
    practitionerSummary:practitionerSummary,
    exportPractitioner:exportPractitioner,
    shareRoutine:shareRoutine,
    productChanges:function(limit){return arr(read().productChanges).slice(0,Number(limit)||10)},
    stackVersions:function(limit){return arr(read().stackVersions).slice(0,Number(limit)||10)},
    conflicts:function(limit){return arr(read().conflicts).slice(0,Number(limit)||10)},
    decisionHistory:function(limit){return arr(read().decisionHistory).slice(0,Number(limit)||10)},
    resolveConflict:resolveConflict,
    compareStackVersion:compareStackVersion,
    restoreStackVersion:restoreStackVersion,
    undoLast:undoLast,
    applyRoutineChanges:applyRoutineChanges,
    identityConfirm:identityConfirm,
    fieldAgeDays:fieldAgeDays,
    printRoutinePassport:printRoutinePassport,
    personalisation:personalisation,
    setDisplayName:setDisplayName,
    setAvatarMeta:setAvatarMeta,
    clearAvatarMeta:clearAvatarMeta,
    commercialState:commercialState,
    entitled:entitled,
    featureFlags:featureFlags,
    trackUsage:trackUsage,
    usage:function(){return JSON.parse(JSON.stringify(read().platform.usage))},
    reviewDue:reviewDue,
    setReviewPreferences:setReviewPreferences,
    markReviewComplete:markReviewComplete,
    neutralityPolicy:function(){return Object.assign({},read().platform.neutrality)},
    syncStatus:function(){return Object.assign({},syncState)},
    syncPull:syncPull,
    syncPush:syncPush,
    refresh:function(){emit(read())}
  };

  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-co-save-type]');
    if(!b)return;
    var type=b.getAttribute('data-co-save-type');
    if(!validType(type))return;
    var payload={};
    try{payload=JSON.parse(b.getAttribute('data-co-save-payload')||'{}')}catch(err){}
    if(!payload.title&&b.getAttribute('data-co-title'))payload.title=b.getAttribute('data-co-title');
    if(!payload.name&&b.getAttribute('data-co-name'))payload.name=b.getAttribute('data-co-name');
    if(!payload.summary&&b.getAttribute('data-co-summary'))payload.summary=b.getAttribute('data-co-summary');
    if(!payload.meta&&b.getAttribute('data-co-meta'))payload.meta=b.getAttribute('data-co-meta');
    if(!payload.href&&b.getAttribute('data-co-href'))payload.href=b.getAttribute('data-co-href');
    var action=b.getAttribute('data-co-save-action')||'save';
    if(action==='save-open')saveAndOpen(type,payload,b.getAttribute('data-co-anchor')||'');
    else save(type,payload);
    b.classList.add('is-saved');
    b.setAttribute('aria-pressed','true');
    var label=b.getAttribute('data-co-saved-label');
    if(label)b.textContent=label
  });

  document.addEventListener('coreoptimise:save',function(e){
    var d=e.detail||{};
    if(validType(d.type))save(d.type,d.item||{})
  });

  document.dispatchEvent(new CustomEvent('coreoptimise:account-ready',{detail:{api:window.CoreOptimiseAccount}}));
  if(syncEndpoint&&signedIn)setTimeout(function(){syncPull().then(function(ok){if(ok)scheduleSyncPush()})},40)
})();